import React from "react";
import {observer} from "mobx-react-lite";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {ClinicalPresentation} from "./clinicalPresentation";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const ClinicalPresentationPage = observer(() => {
  const nursingHomeId = nursingHomeStore.getId();
  return <ConsentDocumentsLayout>{nursingHomeId
    ? <ClinicalPresentation nursingHomeId={nursingHomeId}/>
    : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home to present this consent document."/>
  }</ConsentDocumentsLayout>;
});
